import * as React from 'react';
import {Outlet} from 'react-router-dom';
import styles from '../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default function Root() {

  const userAgent = window.navigator.userAgent;
  const isMobile = userAgent.indexOf('Android') > 0 && userAgent.indexOf('Mobile') > 0;

  return (
    <>
      {isMobile ?
        <Outlet />:
        <div className={cx('mpi-all-wrap')}>
          <div className={cx('mpi-bg')}></div>
          <div className={cx('mpi-pop-wrap')}>
            <Outlet />
          </div>
        </div>
      }
    </>
  );
}